// @flow
import React, { Component } from 'react'
import EarningsAnnouncementView from '../tab-earnings'
import CompanyView from '../tab-company'
// import TradeAnalysisView from '../tab-trade-analysis'
// import TargetsList from '../list-targets'
import { StyledContent } from './style'
import { Row, Col, Tabs } from 'antd'
const TabPane = Tabs.TabPane

type State = {
  selectedTab: string
}

class EarningsView extends Component<{}, State> {

  state: State = {
    selectedTab: '1'
  }

  handleTabChange = (selectedTab: string) => {

    // update selected tab
    this.setState({ selectedTab })
  }

  render() {
    return (
      <Row>
        <Col span={25}>
          <StyledContent>
            <Tabs
              activeKey={this.state.selectedTab}
              onChange={this.handleTabChange}>

              <TabPane tab='Overview' key='1'>
                <EarningsAnnouncementView />
              </TabPane>

              <TabPane tab='Company View' key='2'>
                <CompanyView />
              </TabPane>

              {/*<TabPane tab='Trade Analysis' key='3'>*/}
                {/*<TradeAnalysisView />*/}
              {/*</TabPane>*/}
              
            </Tabs>
          </StyledContent>
        </Col>
        
        {/*<Col span={5}>*/}
          {/*<TargetsList onTabClick={this.handleTabChange} />*/}
        {/*</Col>*/}
      </Row>
    )
  }
}

export default EarningsView



// WEBPACK FOOTER //
// ./src/components/view-earnings/index.js